import { Navigate, Route, Routes } from 'react-router-dom';
import { Keyed } from '../../shared/components/Common';
import InsuranceSearch from './InsuranceSearch';
import InsuranceList from './InsuranceList';
import InsuranceDetails from './InsuranceDetails';
import InsuranceReview from './InsuranceReview';
import InsuranceConfirmation from './InsuranceConfirmation';
import InsuranceBookings from './InsuranceBookings';
import InsuranceBookingDetails from './InsuranceBookingDetails';

// Mounted at /insurance/*
export default function InsuranceRoutes() {
  return (
    <Routes>
      <Route index element={<InsuranceSearch />} />
      <Route path="results" element={<Keyed page={InsuranceList} />} />
      <Route path="plan" element={<Keyed page={InsuranceDetails} />} />
      <Route path="review" element={<InsuranceReview />} />
      <Route path="confirmation/:bookingId" element={<InsuranceConfirmation />} />
      <Route path="bookings" element={<InsuranceBookings />} />
      <Route path="bookings/:bookingId" element={<InsuranceBookingDetails />} />
      <Route path="*" element={<Navigate to="/insurance" replace />} />
    </Routes>
  );
}
